import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist, Drawer, Field, Input, Select } from '@itds/elements/index.js';
import { STATES } from '@itds/Constants';

import Api from '@carrier/utils/Api';

const Edit = ({ eticket, onClose, onSave, relationship, show }) => {
  const [errors, setErrors] = useState([]);
  const [products, setProducts] = useState([]);
  const [data, setData] = useState({
    id: null,
    name: '',
    is_test: false,
    states: [],
    product_ids: []
  });

  useEffect(() => {
    Api.loadProducts({ carrier_id: relationship.carrier_id }).then(({ data }) => {
      setProducts(data);
    });
  }, []);

  useEffect(() => {
    const new_eticket = eticket || {};

    setData({
      id: new_eticket.id,
      name: new_eticket.name || '',
      is_test: !!new_eticket.is_test,
      states: new_eticket.states || [],
      product_ids: new_eticket.product_ids || []
    });
  }, [eticket]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleEnvironmentChange = e => {
    setData({ ...data, is_test: e.target.value === 'test' });
  };

  const handleSelectChange = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      const { id, ...payload } = data;

      Api.saveEmbeddableEticket(id, {
        ...payload,
        vendor_id: relationship.vendor_id,
        carrier_id: relationship.carrier_id
      }).then(() => {
        onSave();
      });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>
          {data.id ? 'Save Changes' : 'Create Embeddable E-Ticket'}
        </Button>
      }
      onClose={onClose}
      show={show}
      title={data.id ? 'Editing Embeddable E-Ticket' : 'New Embeddable E-Ticket'}
    >
      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          required={true}
          value={data.name}
        />
      </Field>

      <Field label='Environment'>
        <Select
          onChange={handleEnvironmentChange}
          options={[
            { value: 'test', label: 'Test' },
            { value: 'production', label: 'Production' }
          ]}
          value={data.is_test ? 'test' : 'production'}
        />
      </Field>

      <Field label='Enabled Products'>
        <Checklist
          onChange={handleSelectChange.bind(null, 'product_ids')}
          options={products
            .filter(p =>
              relationship.permissions.li_quotes
                ? relationship.permissions.li_quotes.includes(p.id)
                : null
            )
            .map(p => ({ value: `${p.id}`, label: p.product_name }))}
          selected={data.product_ids}
          showSelectAll={true}
        />
      </Field>

      <Field label='Enabled States'>
        <Checklist
          onChange={handleSelectChange.bind(null, 'states')}
          options={STATES}
          selected={data.states}
          showSelectAll={true}
        />
      </Field>
    </Drawer>
  );
};

Edit.propTypes = {
  eticket: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  relationship: PropTypes.object,
  show: PropTypes.bool
};

export default Edit;
